"use client";

import { usePathname } from "next/navigation";
import { ReactNode, useEffect } from "react";
import { NavBar } from "./NavBar";

const DARK_PREFIXES = ["/trainer", "/admin"];

function isDarkPath(pathname: string): boolean {
  // Exact segment match only — "/trainer" (кабинет) is dark, but "/trainers/[id]" (публичная
  // страница тренера) is not, even though it also starts with the string "/trainer".
  return DARK_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export function ThemeShell({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const isDark = isDarkPath(pathname);

  useEffect(() => {
    // globals.css's `body { background: var(--color-background) }` inherits --color-background
    // from wherever it's redefined — [data-theme="dark"] on this component's own wrapper div is
    // a DESCENDANT of <body>, so that override never reaches body's own background rule. Body
    // stayed permanently light, and on any route whose content was shorter than the viewport the
    // light body showed through below the dark div ("half black, half white"). Mirroring the
    // attribute onto <html> puts the override on an ANCESTOR of body, which fixes it for real.
    document.documentElement.dataset.theme = isDark ? "dark" : "";
  }, [isDark]);

  return (
    <div data-theme={isDark ? "dark" : undefined} className="flex min-h-screen flex-col bg-background text-text">
      <NavBar isDark={isDark} />
      <main className={`mx-auto w-full flex-1 px-4 py-6 ${isDark ? "max-w-6xl" : "max-w-5xl"}`}>{children}</main>
    </div>
  );
}
